<script>
	import { getContext, createEventDispatcher, onDestroy } from 'svelte'
	import { styles } from '../library/scripts/styles'
	import { getCookie, setCookie } from '../library/scripts/cookie'
	import {
		storeUpdateSingle,
		storeShowSliderButton,
		storeShowGalleryButton,
		storeShowBooking,
		storeFinishedContent,
		storeLogoDropper,
		storeLogo,
		storeFoods,
		storeDrinks,
		storeBooking,
		storeRooms,
		storeShop,
		storeData,
		storeShowCreateButtons,
		storeSocial,
	} from '../library/scripts/Store.svelte'
	import { get_config_file, get_finished_content } from '../library/scripts/utils.js'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../library/ShadersAndSpinners/SpinnerCircle.svelte'

	const ID = getCookie('id')
	let business = null

	let finishedContent = get_finished_content(ID)
	finishedContent.then((value) => {
		if (value) storeFinishedContent.set({ finishedBlocks: value.finishedBlocks, linkedSites: value.linkedSites })
	})

	const configFile = get_config_file(ID)
	configFile.then((value) => {
		if (value.widgets.indexOf('gallery') < 1) storeShowGalleryButton.set(false)
		if (value.widgets.indexOf('cover-slider') < 1) storeShowSliderButton.set(false)
		if (value.widgets.indexOf('booking') < 1) storeShowBooking.set(false)

		//the logo has ben added
		if (value.logo) storeLogo.set(false)

		business = value.business
		value.blocks.forEach((object) => {
			switch (object.blockName) {
				case 'foods':
					storeFoods.set(false)
					break
				case 'drinks':
					storeDrinks.set(false)
					break
				case 'booking':
					storeBooking.set(false)
					break
				case 'rooms':
					storeRooms.set(false)
					break
				case 'shop':
					storeShop.set(false)
					break
			}
		})
		storeData.set(value)
	})

	//different buttons if its a single block update
	let singleButton
	const stoUpdateSingle = storeUpdateSingle.subscribe((value) => {
		singleButton = value
	})

	const globals = getContext('globals')
	const adminColorMain = globals.adminColorMain
	const fsXS = globals.fsXS
	const adminButtonBgHover = globals.adminButtonBgHover
	const adminInputBgFocus = globals.adminInputBgFocus
	const adminInputBorder = globals.adminInputBorder

	//for the cover - slider
	let showSliderButton
	const stoShowSlider = storeShowSliderButton.subscribe((value) => {
		showSliderButton = value
	})

	//for the gallery
	let showGalleryButton
	const stoShowGallery = storeShowGalleryButton.subscribe((value) => {
		showGalleryButton = value
	})

	//for the logo
	let showLogoButton
	const stoLogo = storeLogo.subscribe((value) => {
		showLogoButton = value
	})

	//foods
	let showFoodsButton
	const stoFoods = storeFoods.subscribe((value) => {
		showFoodsButton = value
	})

	//drinks
	let showDrinksButton
	const stoDrinks = storeDrinks.subscribe((value) => {
		showDrinksButton = value
	})

	//booking
	let showBookingButton
	const stoBooking = storeBooking.subscribe((value) => {
		showBookingButton = value
	})

	//rooms
	let showRoomsButton
	const stoRooms = storeRooms.subscribe((value) => {
		showRoomsButton = value
	})

	//shop
	let showShopButton
	const stoShop = storeShop.subscribe((value) => {
		showShopButton = value
	})

	let storedBlocks
	const stoFinishedBlocks = storeFinishedContent.subscribe((value) => {
		storedBlocks = value.finishedBlocks
	})

	configFile.then((value) => {
		storeData.set(value)
		storeFinishedContent.set({ finishedBlocks: storedBlocks, linkedSites: [] })
		

		finishedContent.then((content) => {
			if (content) {
				if (value.widgets.indexOf('cover-slider') > -1 && !content.finishedBlocks.includes('cover-slider')) {
					storeShowSliderButton.set(true)
				}

				if (value.widgets.indexOf('gallery') > -1 && !content.finishedBlocks.includes('gallery')) {
					storeShowGalleryButton.set(true)
				}
			}
		})
	})

	const dispatch = createEventDispatcher()

	const select_block = (block) => {
		storeShowCreateButtons.set(false)
		if (block === 'logo') storeLogoDropper.set(true)
		if (block === 'social') storeSocial.set(true)
		dispatch('selectblock', { block: block })
	}

	const log_out = () => {
		document.location = '#/'
		setCookie('id', '', -20)
	}

	const open_builder = () => {
		document.location = '/#/builder'
	}

	const open_preview = () => {
		document.location = '#/preview'
	}

	onDestroy(() => {
		stoShowSlider
		stoShowGallery
		stoFinishedBlocks
		stoLogo
		stoDrinks
		stoFoods
		stoRooms
		stoShop
		stoUpdateSingle
		stoBooking
	})
</script>

<div class="button_outer" use:styles={{ fsXS }}>
	{#if !singleButton && $storeShowCreateButtons}
		<div>page action</div>
	{/if}
	<div class="button_container">
		{#await finishedContent}
			<Shader>
				<div slot="content">
					<Spinner info="content loading" color={adminInputBgFocus} />
				</div>
			</Shader>
		{:then blocks}
			{#if !singleButton && $storeShowCreateButtons}
				<button use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }} on:click={open_builder}
					>builder</button
				>
			{/if}

			{#if singleButton}
				<button use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }} on:click={open_builder}
					>builder</button
				>
			{/if}
		{/await}
	</div>
	{#if !singleButton && $storeShowCreateButtons}
		create content
		<div class="button_finished">
			<button
				on:click={() => select_block('block')}
				use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}>block</button
			>

			{#if showSliderButton}
				<button
					on:click={() => select_block('cover-slider')}
					use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}>cover-slider</button
				>
			{/if}

			{#if showGalleryButton}
				<button
					on:click={() => select_block('gallery')}
					use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}
					>gallery
				</button>
			{/if}

			{#if showLogoButton}
				<button
					on:click={() => select_block('logo')}
					use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}>logo</button
				>
			{/if}

			{#if business === 'Online Shop' && showShopButton}
				<button
					on:click={() => select_block('shop')}
					use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}
					>add shop
				</button>
			{/if}

			{#if business === 'Restaurant'}
				{#if showFoodsButton}
					<button
						on:click={() => select_block('foods')}
						use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}
						>add food menu
					</button>
				{/if}

				{#if showDrinksButton}
					<button
						on:click={() => select_block('drinks')}
						use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}
						>add drink menu
					</button>
				{/if}

				{#if showBookingButton}
					<button
						on:click={() => select_block('booking')}
						use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}
						>add booking
					</button>
				{/if}
			{/if}

			{#if business === 'Guest House'}
				{#if showRoomsButton}
					<button
						on:click={() => select_block('rooms')}
						use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}
						>add rooms
					</button>
				{/if}

				{#if showFoodsButton}
					<button
						on:click={() => select_block('foods')}
						use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}
						>add food menu
					</button>
				{/if}

				{#if showDrinksButton}
					<button
						on:click={() => select_block('drinks')}
						use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}
						>add drink menu
					</button>
				{/if}
			{/if}
			<button
				on:click={() => select_block('social')}
				use:styles={{ adminColorMain, fsXS, adminButtonBgHover, adminInputBorder }}>social media</button
			>
		</div>
	{/if}
</div>

<style>
	button {
		background-color: transparent;
		color: var(--adminColorMain);
		border: 1px solid var(--adminInputBorder);
		font-size: var(--fsXS);
		width: clamp(100px, 13vw, 200px);
		margin-right: 1%;
		padding: 1%;
		border-radius: 5px;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--adminButtonBgHover);
	}

	.button_outer {
		display: flex;
		flex-direction: column;
		width: 100%;
		font-size: var(--fsXS);
		margin-left: 2%;
	}

	.button_container {
		display: flex;
		align-items: center;
		width: 100%;
		margin-top: 2%;
		/* margin-left: 2%; */
	}

	.button_finished {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
		align-items: center;
		width: 90%;
		margin-top: 2%;
		margin-right: 2%;
	}
</style>
